import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/dave/checkouts/pyohio/static-website/node_modules/gatsby-theme-catalyst-core/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Seo = makeShortcode("Seo");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Seo title="PyOhio Call for Proposals" mdxType="Seo" />
    <h1 {...{
      "id": "call-for-proposals-information"
    }}>{`Call for Proposals Information`}</h1>
    <blockquote>
      <p parentName="blockquote"><a parentName="p" {...{
          "href": "https://pretalx.com/pyohio-2022/cfp",
          "target": "_blank",
          "rel": "nofollow noopener noreferrer"
        }}>{`The PyOhio CFP`}</a>{` closed on May 15.`}</p>
    </blockquote>
    <p>{`We want to hear from you! PyOhio invites you to submit a proposal for a presentation.
We’re looking for talks on all topics of interest to the PyOhio community.`}</p>
    <p>{`Continuing with the format we’ve used in 2020-2021, we will be presenting all short talks.
When submitting a proposal you can choose one of two talk types:`}</p>
    <ul>
      <li parentName="ul">{`5 minute: quick introduction or overview of a topic`}</li>
      <li parentName="ul">{`10-15 minute: more time for some details without a large time committment from presenters or attendees`}</li>
    </ul>
    <p>{`Talks will be pre-recorded and streamed during the event.
They will be made available for viewing on-demand shortly after streaming.
We will be providing an online venue for discussion and curated Q&A (optional for presenters.)`}</p>
    <p>{`We know some of you have many talk ideas but in order to help with our review process we are
limiting the CFP to 3 proposals per person.
If you submit more than 3 we will ask you to remove those in excess.`}</p>
    <p>{`Submit your proposals at the `}<a parentName="p" {...{
        "href": "https://pretalx.com/pyohio-2022/cfp",
        "target": "_blank",
        "rel": "nofollow noopener noreferrer"
      }}>{`PyOhio CFP site`}</a></p>
    <p><a parentName="p" {...{
        "href": "/2022/speaking/speaker-info"
      }}>{`Information and tips for preparing a presentation`}</a></p>
    <h2 {...{
      "id": "potential-topics"
    }}>{`Potential Topics`}</h2>
    <p>{`This is an incomplete list of potential topics meant as suggestions:`}</p>
    <ul>
      <li parentName="ul">{`API development`}</li>
      <li parentName="ul">{`Career`}</li>
      <li parentName="ul">{`Community`}</li>
      <li parentName="ul">{`Data science`}</li>
      <li parentName="ul">{`DevOps`}</li>
      <li parentName="ul">{`Documentation`}</li>
      <li parentName="ul">{`Front-end development for Python users`}</li>
      <li parentName="ul">{`Hobbies with Python`}</li>
      <li parentName="ul">{`Tech management`}</li>
      <li parentName="ul">{`Testing`}</li>
      <li parentName="ul">{`Tips & patterns`}</li>
      <li parentName="ul">{`Web development and/or frameworks`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      